import React, { useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEye,
  faFileUpload,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const DocumentUpload = ({
  uploadedFile,
  setUploadedFile,
  previewUrl,
  setPreviewUrl,
  register,
  errors,
  setValue,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: useCallback(
      (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file.type !== "application/pdf") {
          toast.error("Please upload a PDF document.");

          return;
        }

        setUploadedFile(file);

        const objectUrl = URL.createObjectURL(file);
        setPreviewUrl(objectUrl);

        setValue("document", file, { shouldValidate: true });
      },
      [setUploadedFile, setPreviewUrl, setValue]
    ),
    maxFiles: 1,
    accept: {
      "application/pdf": [".pdf"],
      // "image/*": [".jpeg", ".jpg", ".png"],
    },
  });

  const handleRemoveFile = () => {
    URL.revokeObjectURL(previewUrl);
    setUploadedFile(null);
    setPreviewUrl(null);

    setValue("document", null, { shouldValidate: true });
  };

  const handleViewFile = () => {
    if (uploadedFile) {
      window.open(previewUrl, "_blank");
    }
  };

  useEffect(() => {
    if (register) {
      register("document", {
        required: "Please upload a document.",
        // validate: (value) => {
        //   // The existence of uploadedFile is checked directly
        //   if (!uploadedFile) {
        //     return "Please upload a document.";
        //   }
        //   return true;
        // },
      });
    }

    return () => {};
  }, [register, uploadedFile]);

  return (
    <div className="">
      {uploadedFile ? (
        <div className="border rounded-md p-4 mb-4 relative group">
          <div className="flex items-center space-x-2">
            <FontAwesomeIcon
              icon={faFileUpload}
              className="text-[#948ae3] text-2xl"
            />
            <div>
              <p className="font-medium">{uploadedFile.name}</p>
              <p className="text-gray-500 text-sm">
                {uploadedFile.size > 1024
                  ? (uploadedFile.size / 1024).toFixed(2) + " KB"
                  : uploadedFile.size + " B"}
              </p>
            </div>
          </div>

          <div className="absolute top-2 right-2 space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <button
              onClick={handleViewFile}
              className="bg-[#cfc9ff] text-black hover:bg-[#948ae3] py-2 px-4 rounded focus:outline-none focus:shadow-outline "
              // className="bg-indigo-700 hover:bg-[#cfc9ff] text-white font-bold py-2 px-3 rounded text-sm"
            >
              <FontAwesomeIcon icon={faEye} className="mr-1" /> View
            </button>
            <button
              onClick={handleRemoveFile}
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-3 rounded text-sm"
            >
              <FontAwesomeIcon icon={faTrash} className="mr-1" /> Remove
            </button>
          </div>
        </div>
      ) : (
        <div
          {...getRootProps()}
          className={`border-2 border-dashed ring-1 rounded-md p-8 text-center cursor-pointer focus:ring-2 focus:ring-[#cfc9ff] ${
            isDragActive ? "border-[#cfc9ff] bg-indigo-50" : "border-gray-300"
          }`}
        >
          <input {...getInputProps()} id="document" />
          <FontAwesomeIcon
            icon={faFileUpload}
            className="text-gray-500 text-4xl mb-2"
          />
          <p className="text-gray-500">
            {isDragActive
              ? "Drop the file here..."
              : "Drag 'n' drop a file here, or click to select a file"}
          </p>
        </div>
      )}
      {errors?.document && (
        <p className="text-red-500 text-xs italic">{errors.document.message}</p>
      )}
    </div>
  );
};
export default DocumentUpload;
